/**
 * ============================================================================
 * [P3-02-D] MetricCards - 메트릭 카드 컨테이너
 *
 * 트래킹 메트릭 데이터를 카드 형태로 표시
 * ============================================================================
 */

import { MetricCard } from './MetricCard'
import type { TrackingMetrics } from '@/hooks/useTrackingData'
import styles from './Tracking.module.css'

// ============================================================================
// Types
// ============================================================================
interface MetricCardsProps {
  metrics: TrackingMetrics
}

// ============================================================================
// [P3-02-D] MetricCards Component
// ============================================================================
export function MetricCards({ metrics }: MetricCardsProps) {
  return (
    <div className={styles.metricCards}>
      {/* 전체 글 */}
      <MetricCard
        label="전체 글"
        value={metrics.totalTexts}
        unit="개"
        icon="📝"
      />

      {/* 전체 글자수 */}
      <MetricCard
        label="전체 글자수"
        value={metrics.totalCharacters.toLocaleString()}
        unit="자"
        icon="🔤"
      />

      {/* 평균 글자수 */}
      <MetricCard
        label="평균 글자수"
        value={metrics.averageChars}
        unit="자"
        icon="📊"
      />

      {/* 이번 주 */}
      <MetricCard
        label="이번 주"
        value={metrics.textsThisWeek}
        unit="개"
        icon="📅"
      />

      {/* 연속 작성 (7일 이상 시 하이라이트) */}
      <MetricCard
        label="연속 작성"
        value={metrics.streak}
        unit="일"
        icon="🔥"
        highlight={metrics.streak >= 7}
      />

      {/* 최장 연속 */}
      <MetricCard
        label="최장 연속"
        value={metrics.longestStreak}
        unit="일"
        icon="🏆"
      />

      {/* 최고 생산 요일 */}
      <MetricCard
        label="최고 생산 요일"
        value={metrics.mostProductiveDay}
        icon="📈"
      />

      {/* 최고 생산 시간 */}
      <MetricCard
        label="최고 생산 시간"
        value={`${metrics.mostProductiveHour}시`}
        icon="⏰"
      />
    </div>
  )
}

export default MetricCards
